import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


function Dashboard() {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f9f9fb' }}>
      <nav className="bg-white shadow-sm" style={{ borderBottom: '1px solid #e5e7eb' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center space-x-4">
              <img 
                src="/assets/logo---dark-with-color.png" 
                alt="Remote Assistant" 
                className="h-8 w-auto"
              />
              <h1 className="text-xl font-montserrat font-semibold" style={{ color: '#222324' }}>
                Admin Portal
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={signOut}
                className="font-inter text-sm font-medium px-3 py-2 rounded-md transition-colors"
                style={{ color: '#979ba4' }}
                onMouseEnter={(e) => e.target.style.color = '#222324'}
                onMouseLeave={(e) => e.target.style.color = '#979ba4'}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <h2 className="text-2xl font-montserrat font-semibold mb-6" style={{ color: '#222324' }}>
            Admin Dashboard
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link
              to="/waitlist"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">📋</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      Waitlist Management
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Review and approve waitlist users
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/templates"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">📝</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      Template Manager
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Configure default business templates
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/analytics"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">📊</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      Analytics
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Site traffic and conversions
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/lookup"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">🔍</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      Business Lookup
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Find business by assistant phone number
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/ledger"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">💳</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      Ledger Manager
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Query and fix prepaid ledger balances
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/tests"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">&#x1F9EA;</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      E2E Test Runner
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Run PSTN tests, view latency and conversations
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/users"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">👤</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      User Manager
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Manage Cognito users and attributes
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/aiops"
              className="bg-white overflow-hidden shadow-sm rounded-2xl hover:shadow-md transition-shadow"
              style={{ border: '1px solid #e5e7eb' }}
            >
              <div className="p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#055efd' }}
                    >
                      <span className="text-white text-lg">&#x1F916;</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-montserrat font-semibold" style={{ color: '#222324' }}>
                      AI Operations
                    </h3>
                    <p className="text-sm font-inter" style={{ color: '#979ba4' }}>
                      Auto-triage, investigator, and checkpoint config
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;